import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const trending = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);

export default function HotTicker() {
  const items = [...trending, ...trending];

  return (
    <section className="bg-accent-500 py-3" aria-label="热榜滚动">
      <div className="flex items-center gap-4 overflow-hidden">
        <div className="flex shrink-0 items-center gap-2 bg-primary-950 px-4 py-1.5 text-xs font-semibold text-accent-300 md:px-6">
          <i className="ri-fire-line text-base"></i>
          本周热榜
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8">
            {items.map((item, index) => (
              <Link
                key={`${item.slug}-${index}`}
                to={`/article/${item.slug}`}
                className="flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-950 transition-opacity hover:opacity-70"
              >
                <i className="ri-arrow-right-s-fill"></i>
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}